import { render } from "./deals-filters.vue?vue&type=template&id=50b218dd&scoped=true"
import script from "./deals-filters.vue?vue&type=script&lang=js"
export * from "./deals-filters.vue?vue&type=script&lang=js"

import "./deals-filters.vue?vue&type=style&index=0&id=50b218dd&scoped=true&lang=scss"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b218dd"]])

export default __exports__